module.exports = __webpack_public_path__ + "img/ProjectBoard.5977957d.jpeg";